import fetcher from '@/utils/fetcher';
import rootLogger from '@/utils/root-logger';

const logger = rootLogger.create('vuex-modules/g2w-session/handouts');

/* eslint no-underscore-dangle: ["error", { "allow": ["_embedded", "_links"] }] */

const mutations = {
  setFetching(state, payload) {
    state.fetching = payload.fetching;
  },

  setFiles(state, payload) {
    state.files = payload.files;
  },

  setFilesFromServiceResponse(state, payload) {
    const files = payload.response._embedded.handouts.map((handout) => {
      const file = {
        name: handout.filename,
        href: handout._links.file.href,
        type: handout.filetype,
        size: handout.bytes
      };

      return file;
    });

    state.files = files;
  },

  setLastFetched(state, payload) {
    state.lastFetched = payload.lastFetched;
  }
};

const actions = {
  async getFiles({
    commit, state, rootState, rootGetters
  }, payload) {
    // https://confluence.ops.expertcity.com/display/collaboration/Handouts+REST+API#HandoutsRESTAPI-gethandoutsGetallhandoutsforagivenwebinarandwebinarkey
    const operation = 'handouts/getFiles';
    const {webinarKey, eventKey, registrantKey} = rootState.g2wSession.joinInfo;
    const sessionAttendeeKey = rootState.g2wSession.me.sessionAttendeeKey;

    logger.log(operation, {webinarKey, registrantKey, sessionAttendeeKey});

    let path = `/api/webinars/${webinarKey || eventKey}`;
    const fetchParams = {};

    if (payload.previewMode && payload.token) {
      path += '/handouts';
      fetchParams.headers = new Headers({
        Authorization: `Token ${payload.token}`
      });
    } else {
      path += `/attendee/${sessionAttendeeKey || registrantKey}/handouts`;
    }

    commit('setFetching', {fetching: true});

    try {
      const url = rootGetters['g2wEnv/globalUrl'](path);
      const response = await fetcher.fetchJSON(url, fetchParams, {operation, quiet: true});

      commit('setFetching', {fetching: false});
      commit('setFilesFromServiceResponse', {response});
      commit('setLastFetched', {lastFetched: Date.now()});

      return state.files;
    } catch (e) {
      commit('setFetching', {fetching: false});
      commit('setFiles', {files: []});
      commit('setLastFetched', {lastFetched: Date.now()});
      return [];
    }
  },

  async reset({commit}) {
    commit('setFetching', {fetching: false});
    commit('setFiles', {files: []});
    commit('setLastFetched', {lastFetched: null});
  }
};

const state = () => ({
  fetching: false,
  files: [],
  lastFetched: null
});

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
